export var AuthErrorCodes;
(function (AuthErrorCodes) {
    AuthErrorCodes["TempUserIsConfirmed"] = "auth.TempUserIsConfirmed";
    AuthErrorCodes["IdentitieDoesNotMatch"] = "auth.IdentitieDoesNotMatch";
    AuthErrorCodes["TempUserMaxEmailResends"] = "auth.TempUserMaxEmailResends";
    AuthErrorCodes["TempUserHasSetPassword"] = "auth.tempuser.HasSetPassword";
    AuthErrorCodes["TempUserNotFound"] = "auth.tempuser.TempUserNotFound";
    AuthErrorCodes["TempUserNotConfirmed"] = "auth.tempuser.TempUserNotConfirmed";
    AuthErrorCodes["AccountNoLongerExists"] = "auth.tempuser.AccountNoLongerExists";
    AuthErrorCodes["WrongCode"] = "auth.tempuser.WrongCode";
    AuthErrorCodes["TempUserMissingParameters"] = "auth.tempuser.MissingParameters";
    AuthErrorCodes["UnverifiedActiveUser"] = "auth.tempuser.UnverifiedActiveUser";
})(AuthErrorCodes || (AuthErrorCodes = {}));
//# sourceMappingURL=authErrorCodes.js.map